module.exports = __webpack_public_path__ + "c3d83d45f4ca6710875a1c6006375f42.png";